import React from 'react';

export const Headline = ({
  key,
  intro,
  main_header,
  sub_header,
  is_main,
  url
}) => {
  const Header = is_main ? 'h1' : 'h2';
  return (
    <header key={key}>
      <a href={url} title={main_header}>
        <Header className="main-header">
          {intro}
          <em>{main_header}</em>
        </Header>
        <div id="main-link-wrapper">
          <h2 className="main-subheader">{sub_header}</h2>
        </div>
      </a>
    </header>
  );
};



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/headlines_slider/headline.jsx